<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="1500px">
            <v-card>
                <v-toolbar class="headline" color="primary" dark>{{ title }}</v-toolbar>
                <v-card-text>
                    <v-form ref="EnergyInputDialogForm" v-model="valid" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col cols="2">
                                    物件名
                                </v-col>
                                <v-col v-if="selectFlg" cols="3">
                                    <ryou-select v-model="selectBuild" :value="selectBuild" :label="'物件名'" :items="buildItems"
                                                 :itemText="'building_name'" :itemValue="'building_id'" :rules="requiredRules">
                                    </ryou-select>
                                </v-col>
                                <v-col v-else cols="3">
                                    <!--{{this.buildItems[this.selectedBuild-1].building_name}}-->
                                    {{this.buildingName}}
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="2">
                                    エネルギー選択
                                </v-col>
                                <v-col v-if="selectFlg" cols="3">
                                    <ryou-select v-model="selectEnergy" :value="selectEnergy" :label="'エネルギー選択'" :items="energyItems"
                                                 :itemText="'code_text'" :itemValue="'code_value'" :rules="requiredRules">
                                    </ryou-select>
                                </v-col>
                                <v-col v-else cols="3">
                                    {{this.energyItems[this.selectedEnergy].code_text}}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="2">
                                    対象年月
                                </v-col>
                                <v-col v-if="selectFlg" cols="3">
                                    <ryou-date-format v-model="selectMonth" :value="selectMonth" :rules="requiredRules" :label="'対象年月'" :format ="'$1/$2'">
                                    </ryou-date-format>
                                </v-col>
                                <v-col v-else cols="3">
                                    {{this.model.input_date}}
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="2">
                                    部屋番号
                                </v-col>
                                <v-col v-if="selectFlg" cols="3">
                                    <ryou-input v-model="room_id" :value="room_id" :rules="roomIdRules" :maxlength="4"></ryou-input>
                                </v-col>
                                <v-col v-else cols="3">
                                    {{model.room_id}}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="2">
                                    今回メータ値
                                </v-col>
                                <v-col cols="3">
                                    <ryou-input v-model="model.now_meter_val" :value="model.now_meter_val" :rules="meterRules" :maxlength="6"></ryou-input>
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="2">
                                    前回メータ値
                                </v-col>
                                <v-col cols="3">
                                    {{model.befor_meter_val}}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="2">
                                    今回使用量
                                </v-col>
                                <v-col cols="3">
                                    <ryou-input v-model="model.now_use_amount" :value="model.now_use_amount" :rules="amountRules" :maxlength="6"></ryou-input>
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="2">
                                    前回使用量
                                </v-col>
                                <v-col cols="3">
                                    {{model.befor_use_amount}}
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'"></ryou-black-btn>
                    <v-spacer></v-spacer>
                    <ryou-black-btn :label="'登録'" :handlerClick="handleOk"></ryou-black-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
</v-dialog>
    </v-row>
</template>

<script>
    import RyouInput from "@/components/formInput/RyouInput.vue";
    import RyouSelect from "@/components/formInput/RyouSelect.vue";
    import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
    import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
    export default {
        components: {
            RyouInput,
            RyouSelect,
            RyouBlackBtn,
            RyouDateFormat
        },
        mounted() {
            this.requiredRules.push(this.GlobalRules.required);
            this.roomIdRules.push(this.GlobalRules.required, this.GlobalRules.counter_4, this.GlobalRules.number);
            this.meterRules.push(this.GlobalRules.required, this.GlobalRules.number, this.GlobalRules.numberMax1000, this.GlobalRules.number_point_2);
            this.amountRules.push(this.GlobalRules.required, this.GlobalRules.number, this.GlobalRules.numberMax1000, this.GlobalRules.number_point_2);
        },
        props: {
            url: {
                type: Object,
                required: true,
                default: () => { }
            },
            selectedBuild: {
                type: Number,
                required: true,
                deault: () => { }
            },
            selectedEnergy: {
                type: Number,
                required: true,
                deault: () => { }
            },
            buildItems: {
                type: Object,
                required: true,
                deault: () => { }
            },
            energyItems: {
                type: Object,
                required: true,
                deault: () => { }
            },
            roomItems: {
                type: Object,
                required: true,
                deault: () => { }
            }

        },
        data: () => ({
            selectFlg:true,
            dialog: false,
            title: "",
            valid: true,
            buildingName:"",
            selectBuild:"",
            selectEnergy: "",
            selectMonth: "",
            room_id:"",
            buildItems: [],
            energyItems: [],
            requiredRules: [],
            roomIdRules: [],
            meterRules: [],
            amountRules: [],
            model: {
                befor_meter_val: "0",
                befor_use_amount: "0",
            }
        }),
        watch: {
            selectBuild() {
                this.getAmountRecord()
            },
            selectEnergy() {
                this.getAmountRecord()
            },
            selectMonth() {
                this.getAmountRecord()
            },
            room_id() {
                this.getAmountRecord()
            }
        },
        methods: {
            add() {
                this.selectFlg = true
                this.open();
                this.title = "新規";
            },
            edit(record) {   
                this.selectFlg = false;
                this.buildItems.forEach(x => {
                    if (x.building_id == this.selectedBuild) {                       
                        this.buildingName = x.building_name
                    }
                })
                this.open();
                this.title = "更新";
                setTimeout(() => {
                    this.model = Object.assign({}, record);
                    this.model.input_date = record.input_date.substr(0, 7).replace('-', '/') 
                }, 10);
                
            },
            handleOk() {
               // console.log(this.checkRoomId())
                var valid = this.$refs.EnergyInputDialogForm.validate();
                console.log(valid)
                if (valid) {
                    var that = this;
                    if (!this.selectFlg) {
                        let params = {
                            energyClass: parseInt(this.selectedEnergy),
                            building_id: parseInt(this.selectedBuild),
                            room_id: this.model.room_id,
                            input_date: new Date(this.model.input_date),
                            now_meter_val: parseFloat(this.model.now_meter_val),
                                use_amount: parseFloat(this.model.now_use_amount),
                            upd_user_id: this.$store.getters.getUserId,

                        };
                        params.input_date.setHours(params.input_date.getHours() +9)
                        this.putRequest(this.url.update, params, this.$store.getters.getUserToken).then(resp => {
                            if (resp.success) {
                                that.$emit("ok");
                            }
                            that.close();
                        });
                    } else if (valid && this.checkRoomId()) {
                        //console.log(this.selectMonth)
                        let params = {
                            energyClass : parseInt(this.selectEnergy),
                            building_id: parseInt(this.selectBuild),
                            room_id: this.room_id,
                            input_date: new Date(this.selectMonth),
                            now_meter_val: parseFloat(this.model.now_meter_val),
                            befor_meter_val: parseFloat(this.model.befor_meter_val),
                            use_amount: parseFloat(this.model.now_use_amount),
                            reg_user_id: this.$store.getters.getUserId,
                            upd_user_id: this.$store.getters.getUserId,
                        };
                        //console.log(params)
                        this.postRequest(this.url.add, params, this.$store.getters.getUserToken).then(resp => {
                            if (resp.success) {
                                that.$emit("ok");
                            }
                            that.close();
                        });
                    }
                }
            },
            handleCancel() {
                this.close();
            },
            close() {
                this.dialog = false;
                this.model.befor_meter_val = 0
                this.model.befor_use_amount = 0
            },
            open() {
                this.dialog = true;
                if (this.$refs.EnergyInputDialogForm) {
                    this.$refs.EnergyInputDialogForm.reset();
                    this.$refs.EnergyInputDialogForm.resetValidation();
                }
            },
            checkRoomId() {
                for (let i = 0; i < this.roomItems.length; i++) {
                    if (this.selectBuild == this.roomItems[i].building_id) {
                        if (this.room_id == this.roomItems[i].room_id) {
                            return true
                        }
                    }         
                }
                this.$toast.open({
                    message: "登録できませんでした。使用されていない部屋です。",
                    type: "warning"
                });
                return false
            },
            getAmountRecord() {
                if (this.selectEnergy != "" && this.selectBuild != "" && this.model.room_id != "" && this.selectMonth != "") {
                    let params = {
                        energy_class: parseInt(this.selectEnergy),
                        building_id: parseInt(this.selectBuild),
                        room_id: this.room_id,
                        input_date: new Date(this.selectMonth),

                    }

                    this.getRequest("/energyInput/amountRecordGet", params, this.$store.getters.getUserToken).then(data => {           //エネルギー区分取得
                        if (data.success) {
                            this.model.befor_meter_val = data.result[0]
                            this.model.befor_use_amount = data.result[1]
                        }
                    })
                }             
            }
        }
    };
</script>

<style>
</style>
